module.exports = __webpack_public_path__ + "img/CHECK.16e79f1c.svg";